export default "__VITE_ASSET__Cy4vJH0i__"